<template>
    <div class="site-wrapper" style="min-height: 900px">

        <header class="site-header">
            <img style="width: 100%" :src="require('@/assets/img/bigScreen/title.png')" alt="">
            <p class="site-header__weather">
<!--                <i class="weatherIcon wendu"></i>-->
                温度：{{temperature}}℃ &nbsp;&nbsp; 天气：{{weatherInfo.type}} &nbsp; 风向：{{weatherInfo.fengxiang}}
            </p>
            <p class="site-header__time">
                {{nowTime}}
            </p>
        </header>
        <div style="clear: both"></div>
        <div class="content">
            <el-row :gutter="20" >
                <el-col :span="8">
                    <el-col :span="10" >
                        <div class="dataWrapper">
                            <p class="title">今日评标数</p>
                            <img style="width: 100%" :src="require('@/assets/img/bigScreen/icon2.png')" alt="">
                            <p>{{projectSize}}</p>
                        </div>
                    </el-col>
                    <el-col :span="10" :offset="2" >
                        <div class="dataWrapper">
                            <p class="title">场内专家数</p>
                            <img style="width: 100%" :src="require('@/assets/img/bigScreen/icon1.png')" alt="">
                            <p>{{peopleSize}}</p>
                        </div>
                    </el-col>
                    <el-col :span="24" class="el-top" style="margin-top: 10px">
                        <div class="videoLeft">
                            <img style="width:100%;" :src="require('@/assets/img/bigScreen/up1-1.png')" alt="">
                            <p class="title">评标区域实名见证</p>
                            <div class="videoWrapper">
                                <el-row style="border:2px solid rgb(27,95,203);margin-bottom: 6px">
                                    <el-col :span="24" style="height:3rem">
                                        <simpleFlv :videoUrl.sync="videoUrlBig" videoCode="flv"  :controls="false"></simpleFlv>
                                    </el-col>
                                </el-row>

                                <el-row style="border:2px solid rgb(27,95,203);">
                                    <el-col :span="12"
                                            v-for="(item,index) in videoUrlListCopy" :key="index"
                                            style="min-height:1.5rem"
                                            :style="{'border-bottom':((index>1)?'none':'2px solid rgb(27,95,203)'),'border-right':((index%2 ==0)?'2px solid rgb(27,95,203)':'none')}" >
                                        <simpleFlv
                                                :videoUrl.sync="item.playUrl"
                                                videoCode="flv"
                                                :controls="false">
                                        </simpleFlv>
                                    </el-col>
                                </el-row>

                            </div>
                            <img style="width:100%;margin-top: -15px;"  :src="require('@/assets/img/bigScreen/down1-1.png')" alt="">
                        </div>


                    </el-col>
                </el-col>
                <el-col :span="16">
                    <el-col :span="24" >
                        <div class="videoRight">
                            <img style="width:100%;" :src="require('@/assets/img/bigScreen/up1-2.png')" alt="">
                            <p class="title">专家行动轨迹见证</p>
                            <div style="padding:0px 24px;">
                                <div style="border:4px solid rgb(27,95,203)">
                                    <iframe :src="iframeUrl"  width="100%" :height="4*rem" frameborder="0"></iframe>
                                </div>
                            </div>
                            <img style="width:100%;margin-top: -20px" :src="require('@/assets/img/bigScreen/down1-2.png')" alt="">
                        </div>
                    </el-col>
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="personWrapper">
                            <img style="width:100%;" :src="require('@/assets/img/bigScreen/up1-2.png')" alt="">
                            <p class="title">进入评标区域人员见证</p>
                            <div style="padding: 0 24px;">
                                <el-row :gutter="24" style="min-height:1.5rem">
                                    <el-col :span="4" style="padding: 0;" v-for="(item, index) in personDataList.slice(0, 6)"  :key="index" >
                                        <div class="userCard">
                                            <img style="width:100%;" :src="require('@/assets/img/bigScreen/userbg.png')" alt="">
<!--                                            <div class="temperature">-->
<!--                                                <span>{{item.temperature}}</span>-->
<!--                                            </div>-->
                                            <div class="personImg" style="background: #ffffff">
                                                <img :src="require('@/assets/img/bigScreen/defaultHead.png')" v-real-img="item.imgUrl"   @onerror="defaultImg" alt="">
                                            </div>

                                            <div class="personInfo">
                                                <span><span :class="item.nolegalEnter == 0?'dangerColor':''">{{item.personName}}</span>&nbsp;&nbsp;|&nbsp;&nbsp;专员</span>
                                                <br>
                                                <span>{{ formatDate( item.comeinTime,'MM-dd HH:mm:ss')}}</span>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <img style="width:100%;margin-top: -20px" :src="require('@/assets/img/bigScreen/down1-2.png')" alt="">
                        </div>
                    </el-col>
                </el-col>
            </el-row>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

    </div>
</template>

<script>
    import $ from 'jquery'
    import {mapState} from "vuex";
    import simpleFlv from "@/components/videoPlayer/simpleFlv";

    export default {
        components: {
            simpleFlv
        },
        data () {
            return {
                dialogVisible: false,
                iframeUrl:"",
                dialogImageUrl:"",
                projectSize:0,
                peopleSize:0,
                // videoUrlBig:"rtsp://admin:1234qwer@192.168.2.251/Streaming/Channels/101",
                videoUrlBig:"",
                weatherInfo:{
                    type:null,
                    fengxiang:null,
                },
                timer:null,
                temperature:null,
                videoUrlList:[
                    {playUrl:''},
                    {playUrl:''},
                    {playUrl:''},
                    {playUrl:''}
                ],
                // videoUrlList:[
                //     "rtmp://58.200.131.2:1935/livetv/cctv2",
                //     'rtmp://58.200.131.2:1935/livetv/cctv3',
                //     'rtmp://58.200.131.2:1935/livetv/cctv4',
                //     'rtmp://58.200.131.2:1935/livetv/cctv5',
                // ],
                videoUrlListCopy:[],
                defaultImg: require('@/assets/img/bigScreen/defaultHead.png'),
                height1:(document.documentElement.clientHeight - 211) + "px",
                height2:(document.documentElement.clientHeight - 312) + "px",
                rem:window.innerWidth*100/ 1920,
                personDataList:[],
                // srcList: [
                //     'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
                //     'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
                // ],

                nowTime:'',
                timerCount:0,
                nowTimer:null

            }
        },
        computed: {
            ...mapState({
                stateData:state=>state.user
            }),
        },
        filters:{

        },
        activated () {

        },
        created() {
            this.timeFormate(new Date())
            this.getServerIp();
        },
        watch:{
            videoUrlList: {
                immediate: true,
                handler (val) {
                    this.videoUrlListCopy = val
                },
                deep: true
            },
        },


        mounted() {

            this.setInterVal();
            this.getBidInfo();
            this.getVideoInfo();
            this.getWeatherInfo();
            this.getPersonList();


        },
        destroyed() {

            this.clear()
        },
        methods: {

            getServerIp(){

                // 查询iframe Ip地址
                this.$http.get('/document/sysPersonFaces/UWebUrl').then(res => {
                    if (res.data.code === '1') {
                        let serverIp =res.data.data;
                        if(serverIp){
                            this.iframeUrl = 'http://' + serverIp + "/EHCommon/MenuRealTime/RealTime/realTime2D"
                        }else{
                            // http://192.168.1.59/EHCommon/MenuRealTime/RealTime/realTime2D
                            this.iframeUrl = "http://192.168.1.59/EHCommon/MenuRealTime/RealTime/realTime2D"
                        }
                    }
                })
            },

            imgloaderror(event) {
                event.target.src = this.defaultImg;
                event.target.style = "padding:0 24%"
                // 控制不要一直跳动
                event.target.onerror = null;
            },

            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
                let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
                let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
                let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
                let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
                let week = new Date(timeStamp).getDay();
                let weeks = ["日","一","二","三","四","五","六"];
                let getWeek = "星期" + weeks[week];
                this.nowTime = year + "年" + month + "月" + date +"日  " + getWeek +"  "+hh+":"+mm+':'+ss ;
            },

            showFile(url){
                this.dialogImageUrl=url;
                this.dialogVisible = true;
            },
            getPersonList(){

                this.$http.post("/configs/evalAreaComing/list",{
                    orderBy:'create_time desc'
                }).then(({data}) => {
                    if(data){
                        this.personDataList = data.rows || []
                    }
                })


            },
            getBidInfo(){

                this.$http.get('/fieldAppLys/jzTradDingParTers/getNumberPeopleAndProjects').then(({ data }) => {
                    if (data.code == "1") {
                        this.projectSize = data.data.projectSize;
                        this.peopleSize  = data.data.peopleSize;
                    }
                });

            },
            // 获取大屏监控video路径
            getVideoInfo(){

                this.$http.get("/configs/sysEvalBgDataVideo/getAIStreamUrl").then(({data}) => {
                    if(data){
                        this.videoUrlBig = data.data.streamUrl || '';

                    }
                })

                this.$http.get("/device/listPlayUrl?num=4").then(res => {

                    if(res.data.code == '1'){
                        const urlList = res.data.data || [];
                        // this.videoUrlList = urlList;
                        const that = this;
                        that.videoUrlList.forEach((item,index)=>{
                            if(urlList[index] && urlList[index].playUrl && that.videoUrlList[index].playUrl !== urlList[index].playUrl){
                                that.videoUrlList[index].playUrl = urlList[index].playUrl;
                            }else{
                                that.videoUrlList[index].playUrl = ''
                            }
                        })
                    }
                })

            },

            getWeatherInfo(){
                const _this = this;
                $.ajax({
                    type:"get",
                    // scriptCharset: 'utf-8',
                    // dataType: "json",
                    contentType: "application/x-www-form-urlencoded; charset=utf-8",
                    url:'http://wthrcdn.etouch.cn/weather_mini?city=杭州市',
                    success:function(resdata){
                        resdata = JSON.parse(resdata)
                        if(resdata.status == 1000){
                            _this.weatherInfo =  resdata.data.forecast[0];
                            _this.temperature = resdata.data.wendu;
                        }


                    }
                });
            },


            setInterVal(){

                clearInterval(this.nowTimer);
                const _this = this;
                this.nowTimer = setInterval(function () {
                    ++_this.timerCount;
                    if(_this.timerCount>3000){
                        _this.timerCount = 0
                    }

                    // 页面时间渲染
                    _this.timeFormate(new Date());

                    // 获取进入评标区域人员 数据
                    if((_this.timerCount % 5) == 0){
                        _this.getPersonList();
                    }
                    // 获取 评标区域实名见证 视频流URL
                    if((_this.timerCount % 10) == 0){
                        _this.getVideoInfo();
                    }



                },1000);

            },
            clear(){

                clearInterval(this.nowTimer)
                clearInterval(this.timer);
                this.nowTimer = null;
                this.timer = null;

            },


            routerPage(pageName){
                this.$router.push({
                    name:pageName,
                })
            },






        },
    }
</script>
<style lang="less" scoped>




    .site-wrapper{
        background: url(../../assets/img/bigScreen/bj.jpg) no-repeat 100% 100%;
        background-size: 100% 100%;
        height: 100%;
        width: 100%;
        color:#01fff6;

        .site-header{

            .site-header__weather{
                text-align: left;
                margin: 0;
                padding-left: 16px;
                font-size: 0.2rem;
                position: absolute;
                top: 4%;
                position: fixed;
                left: 0px;

                i.weatherIcon{
                    width: 20px;
                    height: 20px;
                    background: url(../../assets/img/bigScreen/weather.png) no-repeat 100% 100%;
                }


            }
            .site-header__time{

                text-align: right;
                margin: 0;
                padding-right: 16px;
                font-size: 0.2rem;
                position: absolute;
                top: 4%;
                position: fixed;
                right: 0;

            }

        }
        .videoLeft{
            background: url(../../assets/img/bigScreen/shadowbj1.png) no-repeat 100% 100%;
            background-size: 100%;
            .videoWrapper{
                /*height: 6rem;*/
                padding: 0 24px;
                .videoCol{
                    border-bottom:2px solid rgb(27,95,203);
                }
            }

        }
        .videoRight{
            background: url(../../assets/img/bigScreen/shadowbj2.png) no-repeat 100% 100%;
            background-size: 100%;
        }
        .personWrapper{
            background: url(../../assets/img/bigScreen/shadowbj3.png) no-repeat 100% 100%;
            background-size: 100%;
        }
        .videoLeft, .videoRight, .personWrapper{
            position: relative;
            p{
                position: absolute;
                top: 1%;
                left: 30px;
            }

            .userCard{
                text-align: center;
                position: relative;
                font-size: 0.2rem;
                .personImg{
                    position: absolute;
                    max-height: fit-content;
                    width: 80%;
                    top: 12%;
                    left: 10%;
                    img{
                        width:100%;
                    }
                }
                .temperature{
                    position:absolute;
                    padding: 4px;
                    opacity: 0.6;
                    background: #0c1a2c;
                    z-index: 100;
                    top:93px;
                    right: 10%;
                }
                .personInfo{
                    text-align:left;
                    position:absolute;
                    bottom:22px;
                    left: 10%;
                    line-height: 0.3rem;

                }

            }

        }



        .content{
            padding:0px 24px;
            p{
                font-size: 0.2rem;
                font-weight: 600;
            }
            p.title{
                color: #00caf0;
                opacity: 0.8;
                text-shadow: 0px 0px 10px #00caf0;
            }

            .dataWrapper{
                position: relative;
                p{
                    position: absolute;
                }
                p:first-child{
                    top: -28%;
                    right: 10%;

                }
                p:last-child{
                    top: 0%;
                    right: 24%;
                    font-size: 0.4rem;
                }
            }

            .dataWrapper{

            }



        }
    }



</style>
